import axios, { InternalAxiosRequestConfig } from 'axios';

const isLocalhost = (hostname: string): boolean =>
  hostname === 'localhost' || hostname === '127.0.0.1';

const hasExplicitProtocol = (value: string): boolean =>
  /^[a-z][a-z\d+\-.]*:\/\//i.test(value.trim());

export const normalizeToSecureUrl = (rawUrl: string): string => {
  const currentProtocol = window.location.protocol;

  if (currentProtocol !== 'https:') {
    return rawUrl;
  }

  try {
    const trimmed = rawUrl.trim();
    const parsed = new URL(trimmed, window.location.origin);

    if (parsed.protocol === 'http:' && !isLocalhost(parsed.hostname)) {
      parsed.protocol = 'https:';
      const normalized = parsed.toString();
      return hasExplicitProtocol(trimmed) ? normalized : normalized.replace(parsed.origin, '');
    }
  } catch (error) {
    // Mantem a URL original caso nao seja parseavel.
  }

  return rawUrl;
};

export const secureRequestConfig = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  if (config.baseURL) {
    config.baseURL = normalizeToSecureUrl(config.baseURL);
  }

  if (typeof config.url === 'string') {
    config.url = normalizeToSecureUrl(config.url);
  }

  return config;
};

export const setupAxiosSecurity = (): void => {
  axios.interceptors.request.use(secureRequestConfig);
};
